import CascateList from "../../../../../../common/components/cascate_list";
import { useCallback } from "react";
import PrimaryButton from "../../../../../../common/components/primary_button";
import DynamicIcon from "../../../../../../common/components/dynamic_icon";
import { DropDown } from "../../../../../../common/domain/models/dropdown";
import { DefaultMultiAutocomplete } from "../../../../../../common/components/default_multi_autocomplete";
import { MaskedInput } from "../../../../../../common/components/masked_inputs/masked_input";

/**
 * Header ContasReceber Lista.
 * 
 */

type Props = {
  ddlIndiceReajuste: DropDown[];
  selectedIdsIndiceReajuste?: number[];
  codigo?: number;

  onClearFilters: () => void;
  handleIdsindiceReajusteChange: (v: number[]) => void;
  handleCodigoChange: (novoCodigo: string | null) => void;

};


export const Header = ({
  ddlIndiceReajuste,
  selectedIdsIndiceReajuste,
  codigo,
  onClearFilters,
  handleCodigoChange,
  handleIdsindiceReajusteChange,

}: Props) => {

  const handleClearFilters = useCallback(() => {
    onClearFilters();
  }, [onClearFilters]);


  return (
    <>
      <CascateList
        title="Filtros"
        defaultOpen>
        <div className="w-full flex flex-col gap-6 items-center justify-center">
          <div className="w-full grid gap-6 grid-cols-1 md:grid-cols-2 lg:grid-cols-2 grid-flow-row-dense">

            <div className="flex col-span-1 md:col-span-2 lg:col-span-2 gap-1 " >
              <div className="w-full">
                <DefaultMultiAutocomplete
                  label='Banco'
                  value={ddlIndiceReajuste.filter(x => selectedIdsIndiceReajuste?.includes(x.id))}
                  options={ddlIndiceReajuste}
                  getOptionLabel={x => x.title}
                  getOptionKey={x => x.id}
                  onChange={x => handleIdsindiceReajusteChange(x?.map(y => y.id) ?? [])} />
              </div>

              <div className="w-full">
                <MaskedInput
                  name={'nrConta'}
                  label={'Número da Conta'}
                  mask="00000"
                  maskPlaceholder="_____"
                  value={codigo?.toString() ?? null}
                  onChange={handleCodigoChange}
                />
              </div>

            </div>


            <div className="flex col-span-1 md:col-span-2 lg:col-span-2 gap-1 justify-end">
              <div className="w-[180px]">
                <PrimaryButton
                  startIcon={<DynamicIcon nameIcon="ClearRounded" size={25} className="text-black" />}
                  buttonColor="yellow"
                  onClick={handleClearFilters}>
                  Limpar filtros
                </PrimaryButton>
              </div>
            </div>

          </div>
        </div>

      </CascateList>
    </>
  );
}